import { Component, OnInit, ViewChild, ViewContainerRef, Injector, ComponentFactoryResolver, ComponentRef, TemplateRef, Input, SimpleChanges, OnChanges, EventEmitter } from '@angular/core';
import { IFormFormatConfigComponent } from '@gsp-wf/biz-process-api';
import { FormFormatConfigComponent } from '../form-format-config/form-format-config.component';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable, Subject } from 'rxjs';
import { FormFormatType } from '../entities/form-format-type';
import { FormFormat } from '../entities/form-format';

declare var System: any;

@Component({
  selector: 'lib-form-config-container',
  templateUrl: './form-config-container.component.html',
  styleUrls: ['./form-config-container.component.css']
})
export class FormConfigContainerComponent implements OnInit, OnChanges {

  private componentRef: ComponentRef<any>;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  @Input()
  formFormatId: string;
  @Input()
  formatConfigId: string;

  @Input() showMethodTab = true;

  //表单格式
  formFormt: FormFormat;

  loaded = new EventEmitter();

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver,
    private http: HttpService
  ) { }

  ngOnInit() {
    // this.showComponentRef();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formFormatId'] && changes['formFormatId'].currentValue) {
      this.showComponentRef();
    } else { // 功能菜单时
      this.componentRef = this.createWFComponentRef();
      this.componentRef.instance.formFormatId = null;
      this.componentRef.instance.formatConfigId = null;
      this.componentRef.instance.showMethodTab = this.showMethodTab;
      this.container.clear();
      this.container.insert(this.componentRef.hostView);
    }
  }

  submit(): Observable<any> {
    return this.componentRef.instance.submit();
  }

  private showComponentRef() {
    this.componentRef = this.createWFComponentRef();
    this.componentRef.instance.formFormatId = this.formFormatId;
    this.componentRef.instance.formatConfigId = this.formatConfigId;
    this.componentRef.instance.showMethodTab = this.showMethodTab;
    this.container.clear();
    this.container.insert(this.componentRef.hostView);
    // if (this.formFormatId) {
      // this.getFormFormatType().subscribe((re: FormFormatType) => {
        // if (re.code === 'wf') {

        // } else {
        //   System.import(re.customImpl)
        //     .then((moduleFactorys: any) => {
        //       const moduleFactory: any = Object.values(moduleFactorys)[0];
        //       const moduleRef = moduleFactory.create(this.injector);
        //       this.componentRef = moduleRef.instance.createCustomComponentRef(this.injector);
        //       this.componentRef.instance.formFormatId = this.formFormatId;
        //       this.componentRef.instance.formatConfigId = this.formatConfigId;
        //       this.componentRef.instance.showMethodTab = this.showMethodTab;
        //       this.container.clear();
        //       this.container.insert(this.componentRef.hostView);
        //     });
        // }
      // });
    // }
  }

  private createWFComponentRef(): ComponentRef<IFormFormatConfigComponent> {
    const cmpF = this.cfr.resolveComponentFactory(FormFormatConfigComponent);
    const cmpR = cmpF.create(this.injector);
    this.formFormt = cmpR.instance.formFormat;
    cmpR.instance.loaded.subscribe(
      (formFormat)=>{
        this.loaded.next(formFormat);
      }
    );
    return cmpR;
  }

  private getFormFormatType(): Observable<any> {
    if (this.formFormatId) {
      const url = `/api/runtime/wf/v1.0/formFormatType/formFormat?formFormat=${this.formFormatId}`;
      return this.http.get(url);
    }
  }

}
